export default [
  {
    ecosystem: "Ethereum",
    name: "ethereum",
    text: "Ethereum",
    logo: require("@/assets/icons/networks/ethereum.svg"),
    logoSmall: require("@/assets/icons/networks/ethereum.svg"),
    config: {
      network: "ethereum",
      explorerAddrLink: "https://etherscan.io/address/",
      explorerAddrTooltip: "View on etherscan",
      explorerTxsLink: "https://etherscan.io/tx/",
    },
    staking: {
      token: "DAI/USDC/USDT/ETH/WBTC",
    },
  },
  {
    ecosystem: "Ethereum",
    name: "kyber",
    projectName: "kyberdao",
    text: "Kyber Network",
    description: `Kyber is a liquidity aggregation protocol that connects liquidity from various protocols and sources to provide the best rates to any DeFi users, built on Ethereum. The Kyber Network Crystal (KNC) is an ERC-20 utility and governance token which has a dynamic supply and can be upgraded, minted, or burned by KyberDAO to better support liquidity and growth.`,
    tokenDescription: `The KyberDAO governance process enable KNC holders to propose and vote on key network parameters, new strategies and mechanisms to improve Kyber in a verifiable manner.`,
    logo: require("@/assets/projects/kyber.svg"),
    logoSmall: require("@/assets/projects/kyber-small.svg"),
    implemented: true,
    isLegacy: true,
    config: {
      network: "ethereum",
      ableToLock: true,
      explorerAddrLink: "https://etherscan.io/address/",
      explorerAddrTooltip: "View on etherscan",
      explorerTxsLink: "https://etherscan.io/tx/",
      fixed: 6,
      rewardFixed: 6,
    },
    staking: {
      token: "knc",
      rewardToken: "eth",
    },
  },
  {
    ecosystem: "Ethereum",
    name: "skale",
    projectName: "skale",
    text: "Skale",
    description:
      "Skale is an Ethereum-compatible blockchain network. Decentralized applications on Skale can scale without compromising on computation, storage and security. SKL is its native token which has a max supply of 7 billion.",
    tokenDescription: `SKL is a <strong>hybrid staking token</strong> used to <strong>secure Skale Elastic Sidechains</strong>, or for <strong>deployment and rental</strong> of a Sidechain for developers. Delegators are also able to <strong>participate in on-chain governance voting</strong> with SKL.`,
    logo: require("@/assets/projects/skale-light.svg"),
    logoDark: require("@/assets/projects/skale-dark.svg"),
    logoSmall: require("@/assets/projects/skale-small-light.svg"),
    logoSmallDark: require("@/assets/projects/skale-small-dark.svg"),
    implemented: true,
    config: {
      network: "ethereum",
      ableToLock: true,
      explorerAddrLink: "https://etherscan.io/address/",
      explorerAddrTooltip: "View on etherscan",
      explorerTxsLink: "https://etherscan.io/tx/",
      fixed: 6,
      rewardFixed: 6,
      calculator: {
        min: 10000,
        max: 1000000,
      },
    },
    staking: {
      token: "skl",
      rewardToken: "skl",
      swuFees: 15,
    },
  },
  {
    ecosystem: "Ethereum",
    name: "thegraph",
    projectName: "thegraph",
    text: "The Graph",
    description: `The Graph is an indexing protocol for querying networks like Ethereum and IPFS. Open APIs, known as subgraphs, make data easily accessible to anyone. GRT is its native work token staked by Indexers, Curators and Delegators for indexing and curating services on the network.`,
    tokenDescription: `GRT is the <strong>work token</strong> that is staked by Indexers, Curators and Delegators for <strong>indexing and curating services</strong> on the network. Inflation is scheduled at 3% annually and query fees will be distributed based on subgraph activity and allocated stake ratio of the indexer.`,
    logo: require("@/assets/projects/graph-light.svg"),
    logoDark: require("@/assets/projects/graph-dark.svg"),
    logoSmall: require("@/assets/projects/graph-small.svg"),
    implemented: true,
    isLegacy: true,
    config: {
      network: "ethereum",
      ableToLock: true,
      explorerAddrLink: "https://etherscan.io/address/",
      explorerAddrTooltip: "View on etherscan",
      explorerTxsLink: "https://etherscan.io/tx/",
      fixed: 6,
      rewardFixed: 6,
      calculator: {
        min: 10000,
        max: 1000000,
      },
    },
    staking: {
      token: "grt",
      rewardToken: "grt",
    },
  },
  {
    ecosystem: "Ethereum",
    name: "celer",
    projectName: "celer",
    text: "Celer",
    description: `Celer is a layer 2 scaling platform that utilizes state channels and rollups to power applications that requires low latency and low-cost transactions, built on Ethereum. CELR is its native utility incentive token which has max supply of 10 billion.`,
    tokenDescription: `CELR token is utilized as an <strong>incentive token</strong> for the <strong>provision of liquidity</strong> and <strong>participation within the State Guardian Network</strong> to different off-chain service providers. `,
    logo: require("@/assets/projects/celer-light.svg"),
    logoDark: require("@/assets/projects/celer-dark.svg"),
    logoSmall: require("@/assets/projects/celer-small-light.svg"),
    logoSmallDark: require("@/assets/projects/celer-small-dark.svg"),
    implemented: true,
    config: {
      network: "ethereum",
      ableToLock: true,
      explorerAddrLink: "https://etherscan.io/address/",
      explorerAddrTooltip: "View on etherscan",
      explorerTxsLink: "https://etherscan.io/tx/",
      fixed: 6,
      rewardFixed: 6,
      calculator: {
        min: 1,
        max: 1000000,
      },
    },
    staking: {
      token: "celr",
      rewardToken: "celr",
      daysLocked: 8,
    },
  },
  {
    ecosystem: "Tendermint",
    name: "cosmos",
    projectName: "cosmos",
    text: "Cosmos",
    description:
      "Cosmos is a decentralized network of interoperable, scalable blockchains, powered by Tendermint. ATOM is its native currency and staking token for the Cosmos Hub.",
    tokenDescription: `ATOM is the native currency and a staking asset for the Cosmos Hub. By delegating ATOM to a validator, delegators will be able to <strong>contribute to the security of the Hub</strong> and <strong>participate in the on-chain governance voting process</strong>. In return, delegators earn <strong>inflationary rewards</strong> and <strong>transaction fees</strong> denominated in ATOM.`,
    logoSmall: require("@/assets/projects/cosmos-small-light.svg"),
    logoSmallDark: require("@/assets/projects/cosmos-small-dark.svg"),
    logo: require("@/assets/projects/cosmos-light.svg"),
    logoDark: require("@/assets/projects/cosmos-dark.svg"),
    implemented: true,
    config: {
      network: "cosmos",
      ableToLock: false,
      explorerAddrLink: "https://www.mintscan.io/cosmos/account/",
      explorerAddrTooltip: "View on mintscan",
      explorerTxsLink: "https://www.mintscan.io/cosmos/txs/",
      proposalDetailsLink: "https://www.mintscan.io/cosmos/proposals/",
      keystation: {
        lcd: process.env.VUE_APP_KEYSTATION_COSMOS_LCD,
        clientWebUrl: window.location.origin,
        prefix: "cosmos",
      },
      txOkTimeout: 10000,
      fixed: 6,
      rewardFixed: 6,
      refreshBlocks: 10,
      keplr: {
        signDirect: true,
        signDirectMsgTypes: ["cosmos-sdk/MsgGrant", "cosmos-sdk/MsgRevoke"],
      },
    },
    staking: {
      denom: "uatom",
      token: "atom",
      conversionRate: 1e6,
      gas: {
        Send: 250000,
        Stake: 350000,
        Unstake: 250000,
        Redelegate: 350000,
        ClaimRewards: 300000,
        Vote: 250000,
        GovDeposit: 250000,
        EnableAutoCompound: 250000,
        DisableAutoCompound: 250000,
      },
      gasPriceStep: {
        fast: 0.04,
        medium: 0.025,
        slow: 0.01,
      },
      bech32Prefix: {
        delegator: "cosmos",
      },
      gov: {
        vote: {
          useOptNumber: true,
        },
      },
      swuFees: 9,
      daysLocked: 21,
      msgsMixed: true,
    },
  },
  {
    ecosystem: "Tendermint",
    name: "kava",
    text: "Kava",
    projectName: "kava",
    description:
      "Kava is a cross-chain multi-collateral loan platform (CDP) for decentralized finance. It is built on the Cosmos SDK powered by Tendermint. KAVA is its native utility and governance token.",
    tokenDescription: `KAVA is a native currency and a staking asset used to <strong>secure the Kava platform</strong>. KAVA delegators are able to <strong>vote on proposals</strong> to change the CDP parameters, such as accepting new collateral types or limiting the amount of USDX to be issued. In return, delegators earn <strong>inflationary rewards</strong> and <strong>transaction fees</strong> denominated in KAVA. All <strong>CDP fees are paid in KAVA and burnt</strong> from the overall supply.`,
    logoSmall: require("@/assets/projects/kava-small.svg"),
    logo: require("@/assets/projects/kava.svg"),
    implemented: true,
    variesApy: true,
    config: {
      network: "kava",
      ableToLock: false,
      explorerAddrLink: "https://www.mintscan.io/kava/account/",
      explorerAddrTooltip: "View on mintscan",
      explorerTxsLink: "https://www.mintscan.io/kava/txs/",
      proposalDetailsLink: "https://www.mintscan.io/kava/proposals/",
      keystation: {
        lcd: process.env.VUE_APP_KEYSTATION_KAVA_LCD,
        clientWebUrl: window.location.origin,
        prefix: "kava",
      },
      txOkTimeout: 10000,
      fixed: 6,
      rewardFixed: 6,
      refreshBlocks: 10,
      keplr: {
        signDirect: true,
        signDirectMsgTypes: ["cosmos-sdk/MsgGrant", "cosmos-sdk/MsgRevoke"],
      },
    },
    staking: {
      denom: "ukava",
      token: "kava",
      conversionRate: 1e6,
      gas: {
        Send: 350000,
        Stake: 350000,
        Unstake: 350000,
        Redelegate: 350000,
        ClaimRewards: 350000,
        Vote: 350000,
        GovDeposit: 350000,
        EnableAutoCompound: 350000,
        DisableAutoCompound: 350000,
      },
      gasPriceStep: {
        fast: 0.04,
        medium: 0.025,
        slow: 0.01,
      },
      bech32Prefix: {
        delegator: "kava",
      },
      gov: {
        vote: {
          useOptNumber: true,
        },
      },
      swuFees: 5,
      daysLocked: 21,
      msgsMixed: true,
    },
  },
  {
    ecosystem: "Tendermint",
    name: "band",
    projectName: "band",
    text: "Band Protocol",
    description:
      "Band is a cross-chain data oracle platform that aggregates real-world data and APIs to smart contracts. It is built on the Cosmos SDK powered by Tendermint. BAND is its native currency and governance token.",
    tokenDescription: `BAND is a native currency and a staking asset used to <strong>secure the Band oracle platform</strong>. BAND delegators are able to <strong>paritcipate in the on-chain governance voting process</strong>. In return, delegators earn <strong>inflationary rewards</strong> and <strong>transaction fees</strong> denominated in BAND.`,
    logoSmall: require("@/assets/projects/band-small-light.svg"),
    logoSmallDark: require("@/assets/projects/band-small-dark.svg"),
    logo: require("@/assets/projects/band-light.svg"),
    logoDark: require("@/assets/projects/band-dark.svg"),
    implemented: true,
    config: {
      network: "band",
      ableToLock: false,
      explorerAddrLink: "https://cosmoscan.io/account/",
      explorerAddrTooltip: "View on BandChain Explorer",
      explorerTxsLink: "https://www.cosmoscan.io/tx/",
      proposalDetailsLink: "https://cosmoscan.io/proposal/",
      txOkTimeout: 10000,
      fixed: 6,
      rewardFixed: 6,
      refreshBlocks: 10,
      keystation: {
        lcd: process.env.VUE_APP_KEYSTATION_BAND_LCD,
        clientWebUrl: window.location.origin,
        prefix: "band",
      },
    },
    staking: {
      denom: "uband",
      token: "band",
      conversionRate: 1e6,
      gas: {
        Send: 250000,
        Stake: 250000,
        Unstake: 250000,
        Redelegate: 350000,
        ClaimRewards: 300000,
        Vote: 250000,
        GovDeposit: 250000,
        EnableAutoCompound: 250000,
        DisableAutoCompound: 250000,
      },
      gasPriceStep: {
        fast: 0.04,
        medium: 0.025,
        slow: 0.01,
      },
      bech32Prefix: {
        delegator: "band",
      },
      gov: {
        vote: {
          useOptNumber: true,
        },
      },
      swuFees: 10,
      daysLocked: 21,
      msgsMixed: true,
    },
  },
  {
    ecosystem: "Tendermint",
    name: "terra",
    projectName: "terra",
    text: "Terra Classic",
    description:
      "Terra is a multi-stablecoin payment network with a price-stable algorithm that balances the money supply, powered by Cosmos.",
    tokenDescription: `Besides being a staking asset to secure the payment network, LUNC functions as an asset to absorb volatility on the price of the stablecoin basket. In return for providing stability and security, delegators are rewarded with transactions fees and seigniorage profits from the network. `,
    logoSmall: require("@/assets/projects/terra-small.svg"),
    logo: require("@/assets/projects/terra.svg"),
    implemented: true,
    config: {
      network: "terra",
      ableToLock: false,
      explorerAddrLink: "https://finder.terra.money/classic/address/",
      explorerAddrTooltip: "View on Terra Finder",
      explorerTxsLink: "https://finder.terra.money/classic/tx/",
      proposalDetailsLink: "https://station.terra.money/proposal/",
      txOkTimeout: 10000,
      fixed: 6,
      rewardFixed: 6,
      refreshBlocks: 10,
      keplr: {
        signDirect: true,
        signDirectMsgTypes: [
          "msgauth/MsgGrantAuthorization",
          "msgauth/MsgRevokeAuthorization",
        ],
      },
    },
    staking: {
      denom: "uluna",
      feeDenom: "uluna",
      token: "lunc",
      conversionRate: 1e6,
      gas: {
        Send: 500000,
        Stake: 500000,
        Unstake: 500000,
        Redelegate: 500000,
        ClaimRewards: 500000,
        Vote: 500000,
        GovDeposit: 500000,
        EnableAutoCompound: 500000,
        DisableAutoCompound: 500000,
      },
      gasPriceStep: {
        fast: 0.04,
        medium: 0.025,
        slow: 0.01,
      },
      bech32Prefix: {
        delegator: "terra",
      },
      msgsMixed: true,
      gov: {
        vote: {
          useOptNumber: true,
        },
      },
      swuFees: 10,
      anchor: {
        gas: {
          Deposit: 1000000,
          Withdraw: 1000000,
        },
        gasPriceStep: {
          fast: 1,
          medium: 0.5,
          slow: 0.25,
        },
      },
      daysLocked: 21,
    },
  },
  {
    ecosystem: "Tendermint",
    name: "terrav2",
    projectName: "terrav2",
    text: "Terra",
    description:
      "The Terra 2.0 protocol is an open source community-owned blockchain which hosts a vibrant ecosystem of applications. It is built on the Cosmos SDK powered by Tendermint. LUNA is its native currency, staking and governance token.",
    tokenDescription: `LUNA is the Terra protocol's native staking token. LUNA is used for governance and in mining. Users stake LUNA to validators who record and verify transactions on the blockchain in exchange for rewards from transaction fees.`,
    logoSmall: require("@/assets/projects/terra-2-small.svg"),
    logo: require("@/assets/projects/terra-2.svg"),
    implemented: true,
    config: {
      network: "terrav2",
      ableToLock: false,
      explorerAddrLink: "https://finder.terra.money/mainnet/address/",
      explorerAddrTooltip: "View on Terra Finder",
      explorerTxsLink: "https://finder.terra.money/mainnet/tx/",
      proposalDetailsLink: "https://station.terra.money/proposal/",
      txOkTimeout: 10000,
      fixed: 6,
      rewardFixed: 6,
      refreshBlocks: 10,
      keplr: {
        signDirect: true,
        signDirectMsgTypes: ["cosmos-sdk/MsgGrant", "cosmos-sdk/MsgRevoke"],
      },
    },
    staking: {
      denom: "uluna",
      feeDenom: "uluna",
      token: "luna",
      conversionRate: 1e6,
      gas: {
        Send: 500000,
        Stake: 500000,
        Unstake: 500000,
        Redelegate: 500000,
        ClaimRewards: 500000,
        Vote: 500000,
        GovDeposit: 500000,
        EnableAutoCompound: 500000,
        DisableAutoCompound: 500000,
      },
      gasPriceStep: {
        fast: 0.2,
        medium: 0.15,
        slow: 0.1,
      },
      bech32Prefix: {
        delegator: "terra",
      },
      msgsMixed: true,
      gov: {
        vote: {
          useOptNumber: true,
        },
      },
      swuFees: 10,
      daysLocked: 21,
    },
  },
  {
    ecosystem: "Tendermint",
    name: "starname",
    projectName: "starname",
    text: "Starname",
    description:
      "Starname is a universal name service that translates blockchain addresses into human-readable addresses. It is built on the Cosmos SDK powered by Tendermint. IOV is its native utility and governance token.",
    logoSmall: require("@/assets/projects/starname-small.svg"),
    logo: require("@/assets/projects/starname-light.svg"),
    logoDark: require("@/assets/projects/starname-dark.svg"),
    implemented: true,
    config: {
      network: "starname",
      ableToLock: false,
      explorerAddrLink: "https://www.mintscan.io/starname/account/",
      explorerAddrTooltip: "View on mintscan",
      explorerTxsLink: "https://www.mintscan.io/starname/txs/",
      proposalDetailsLink: "https://www.mintscan.io/starname/proposals/",
      txOkTimeout: 15000,
      fixed: 6,
      rewardFixed: 6,
      refreshBlocks: 10,
      keystation: {
        lcd: process.env.VUE_APP_KEYSTATION_STARNAME_LCD,
        clientWebUrl: window.location.origin,
        prefix: "star",
      },
      keplr: {
        signDirect: true,
        signDirectMsgTypes: ["cosmos-sdk/MsgGrant", "cosmos-sdk/MsgRevoke"],
      },
    },
    staking: {
      denom: "uiov",
      token: "iov",
      conversionRate: 1e6,
      gas: {
        Send: 250000,
        Stake: 250000,
        Unstake: 250000,
        Redelegate: 350000,
        ClaimRewards: 300000,
        Vote: 250000,
        GovDeposit: 250000,
        EnableAutoCompound: 250000,
        DisableAutoCompound: 250000,
      },
      gasPriceStep: {
        fast: 3,
        medium: 2,
        slow: 1,
      },
      bech32Prefix: {
        delegator: "star",
      },
      gov: {
        vote: {
          useOptNumber: true,
        },
      },
      swuFees: 10,
      daysLocked: 21,
      msgsMixed: true,
    },
  },
  {
    ecosystem: "Tendermint",
    name: "switcheo",
    projectName: "switcheo",
    text: "Switcheo",
    description:
      "Switcheo Tradehub is a dPOS order matching engine built on top of Tendermint Core, built as a sidechain for trading.",
    logoSmall: require("@/assets/projects/switcheo-small.svg"),
    logo: require("@/assets/projects/switcheo-light.svg"),
    logoDark: require("@/assets/projects/switcheo-dark.svg"),
    implemented: false,
    config: {
      network: "switcheo",
      ableToLock: false,
      explorerAddrLink: "https://switcheo.org/account/",
      explorerAddrTooltip: "View on TradeScan",
      explorerTxsLink: "https://switcheo.org/transaction/",
      proposalDetailsLink: "https://switcheo.org/governance/proposal/",
      txOkTimeout: 5000,
      fixed: 6,
      rewardFixed: 6,
      refreshBlocks: 15,
    },
    staking: {
      denom: "swth",
      token: "swth",
      conversionRate: 1e8,
      gas: {
        Send: 1e8,
        Stake: 1e8,
        Unstake: 1e8,
        Redelegate: 1e8,
        ClaimRewards: 1e8,
        Vote: 1e8,
        GovDeposit: 1e8,
      },
      gasPriceStep: {
        fast: 1,
        medium: 1,
        slow: 1,
      },
      bech32Prefix: {
        delegator: "swth",
      },
      gov: {
        vote: {
          useOptNumber: false,
        },
      },
      swuFees: 5,
      daysLocked: 28,
      msgsMixed: true,
    },
  },
  {
    ecosystem: "Tendermint",
    name: "persistence",
    projectName: "persistence",
    text: "Persistence",
    description:
      "Persistence is an ecosystem of financial products focused on institutional and crypto-native use cases. It is built on the Cosmos SDK powered by Tendermint. XPRT is its native staking and governance token.",
    tokenDescription: `XPRT is the <strong>staking asset</strong> to secure and govern Persistence chain. Stakers benefits from economic activity taking place on Persistence dApps or pApps as Persistence has a <strong>revenue sharing / transaction volume based fee agreements</strong> with all the dApps within the ecosystem.`,
    logoSmall: require("@/assets/projects/persistence-small-light.svg"),
    logoSmallDark: require("@/assets/projects/persistence-small-dark.svg"),
    logo: require("@/assets/projects/persistence-light.svg"),
    logoDark: require("@/assets/projects/persistence-dark.svg"),
    implemented: true,
    config: {
      network: "persistence",
      ableToLock: false,
      explorerAddrLink: "https://www.mintscan.io/persistence/account/",
      explorerAddrTooltip: "View on mintscan",
      explorerTxsLink: "https://www.mintscan.io/persistence/txs/",
      proposalDetailsLink: "https://www.mintscan.io/persistence/proposals/",
      keystation: {
        lcd: process.env.VUE_APP_KEYSTATION_PERSISTENCE_LCD,
        clientWebUrl: window.location.origin,
        prefix: "persistence",
      },
      txOkTimeout: 10000,
      fixed: 6,
      rewardFixed: 6,
      refreshBlocks: 10,
      keplr: {
        signDirect: true,
        signDirectMsgTypes: ["cosmos-sdk/MsgGrant", "cosmos-sdk/MsgRevoke"],
      },
    },
    staking: {
      denom: "uxprt",
      token: "xprt",
      conversionRate: 1e6,
      gas: {
        Send: 250000,
        Stake: 250000,
        Unstake: 250000,
        Redelegate: 350000,
        ClaimRewards: 300000,
        Vote: 250000,
        GovDeposit: 250000,
        EnableAutoCompound: 250000,
        DisableAutoCompound: 250000,
      },
      gasPriceStep: {
        fast: 0.04,
        medium: 0.025,
        slow: 0.01,
      },
      bech32Prefix: {
        delegator: "persistence",
      },
      gov: {
        vote: {
          useOptNumber: true,
        },
      },
      swuFees: 10,
      daysLocked: 21,
      msgsMixed: true,
    },
  },
  {
    ecosystem: "Tendermint",
    name: "sentinel",
    projectName: "sentinel",
    text: "Sentinel",
    description:
      "Sentinel is an interoperable network layer for bandwidth sharing and distributed services. It is built on the Cosmos SDK powered by Tendermint. DVPN is its native staking asset and governance token to secure and govern the Sentinel hub.",
    tokenDescription: `DVPN is the <strong>staking asset</strong> to secure and govern Sentinel hub. DVPN is also used to pay for <strong>DVPN node hosting</strong> and has a decreasing inflation reward schedule that is minted from a fixed maximum token supply.`,
    logoSmall: require("@/assets/projects/sentinel-small-light.svg"),
    logoSmallDark: require("@/assets/projects/sentinel-small-dark.svg"),
    logo: require("@/assets/projects/sentinel-light.svg"),
    logoDark: require("@/assets/projects/sentinel-dark.svg"),
    implemented: true,
    config: {
      network: "sentinel",
      ableToLock: false,
      explorerAddrLink: "https://www.mintscan.io/sentinel/account/",
      explorerAddrTooltip: "View on mintscan",
      explorerTxsLink: "https://www.mintscan.io/sentinel/txs/",
      proposalDetailsLink: "https://www.mintscan.io/sentinel/proposals/",
      keystation: {
        lcd: process.env.VUE_APP_KEYSTATION_SENTINEL_LCD,
        clientWebUrl: window.location.origin,
        prefix: "sent",
      },
      txOkTimeout: 10000,
      fixed: 6,
      rewardFixed: 6,
      refreshBlocks: 10,
      keplr: {
        signDirect: true,
        signDirectMsgTypes: ["cosmos-sdk/MsgGrant", "cosmos-sdk/MsgRevoke"],
      },
    },
    staking: {
      denom: "udvpn",
      token: "dvpn",
      conversionRate: 1e6,
      gas: {
        Send: 250000,
        Stake: 250000,
        Unstake: 250000,
        Redelegate: 350000,
        ClaimRewards: 300000,
        Vote: 250000,
        GovDeposit: 250000,
        EnableAutoCompound: 250000,
        DisableAutoCompound: 250000,
      },
      gasPriceStep: {
        fast: 0.4,
        medium: 0.25,
        slow: 0.1,
      },
      bech32Prefix: {
        delegator: "sent",
      },
      gov: {
        vote: {
          useOptNumber: true,
        },
      },
      swuFees: 5,
      daysLocked: 28,
      msgsMixed: true,
    },
  },
  {
    ecosystem: "Tendermint",
    name: "osmosis",
    projectName: "osmosis",
    text: "Osmosis",
    description:
      "Osmosis is an advanced AMM protocol that allows developers to design, build, and deploy their own customized AMMs. It is built on the Cosmos SDK powered by Tendermint. OSMO is its native utility and governance token which has a max supply of one billion.",
    tokenDescription: `OSMO is the native currency and a staking asset for the osmosis AMM Hub. By delegating OSMO to a validator, delegators will be able to <strong>contribute to the security of the AMM Hub</strong> and <strong>participate in the on-chain governance voting process</strong>. In return, delegators earn <strong>inflationary rewards</strong> and <strong>transaction fees</strong> denominated in OSMO.`,
    logoSmall: require("@/assets/projects/osmosis-small-light.svg"),
    logoSmallDark: require("@/assets/projects/osmosis-small-dark.svg"),
    logo: require("@/assets/projects/osmosis-light.svg"),
    logoDark: require("@/assets/projects/osmosis-dark.svg"),
    implemented: true,
    config: {
      network: "osmosis",
      ableToLock: false,
      explorerAddrLink: "https://www.mintscan.io/osmosis/account/",
      explorerAddrTooltip: "View on mintscan",
      explorerTxsLink: "https://www.mintscan.io/osmosis/txs/",
      proposalDetailsLink: "https://www.mintscan.io/osmosis/proposals/",
      txOkTimeout: 10000,
      fixed: 6,
      rewardFixed: 6,
      refreshBlocks: 10,
      keplr: {
        signDirect: true,
        signDirectMsgTypes: ["cosmos-sdk/MsgGrant", "cosmos-sdk/MsgRevoke"],
      },
    },
    staking: {
      denom: "uosmo",
      token: "osmo",
      conversionRate: 1e6,
      gas: {
        Send: 250000,
        Stake: 250000,
        Unstake: 250000,
        Redelegate: 600000,
        ClaimRewards: 300000,
        Vote: 250000,
        GovDeposit: 250000,
        SwapExactAmountIn: 600000,
        EnableAutoCompound: 250000,
        DisableAutoCompound: 250000,
      },
      gasPriceStep: {
        fast: 0.04,
        medium: 0.025,
        slow: 0.01,
      },
      bech32Prefix: {
        delegator: "osmo",
      },
      gov: {
        vote: {
          useOptNumber: true,
        },
      },
      swuFees: 5,
      daysLocked: 14,
      msgsMixed: true,
    },
  },
  {
    ecosystem: "Tendermint",
    name: "certik",
    projectName: "certik",
    text: "Certik",
    description:
      "The Certik Shentu Chain provides a range of built-in components, such as security oracles, to facilitate the handling of security inquiries from other networks. It is built on the Cosmos SDK, powered by Tendermint. CTK is its native utility and governance token, and is used as collateral for the CertiKshield pool.",
    tokenDescription: `CTK is the <strong>collateral for the Certikshield pool</strong>, which can be used to reimburse approved claim proposals. Besides <strong>earning staking rewards</strong>, stakers also gain a portion of the <strong>fees paid by members who reserve the liquidity within the pool</strong> to protect their crypto assets.`,
    logoSmall: require("@/assets/projects/certik-small.svg"),
    logo: require("@/assets/projects/certik-light.png"),
    logoDark: require("@/assets/projects/certik-dark.png"),
    implemented: true,
    config: {
      network: "certik",
      ableToLock: false,
      explorerAddrLink: "https://www.mintscan.io/shentu/address/",
      explorerAddrTooltip: "View on Certik Explorer",
      explorerTxsLink: "https://www.mintscan.io/shentu/tx/",
      proposalDetailsLink:
        "https://www.mintscan.io/shentu/proposals/",
      keystation: {
        lcd: process.env.VUE_APP_KEYSTATION_CERTIK_LCD,
        clientWebUrl: window.location.origin,
        prefix: "certik",
      },
      txOkTimeout: 10000,
      fixed: 6,
      rewardFixed: 6,
      refreshBlocks: 10,
      keplr: {
        signDirect: true,
        signDirectMsgTypes: ["cosmos-sdk/MsgGrant", "cosmos-sdk/MsgRevoke"],
      },
    },
    staking: {
      denom: "uctk",
      token: "ctk",
      conversionRate: 1e6,
      gas: {
        Send: 250000,
        Stake: 250000,
        Unstake: 250000,
        Redelegate: 350000,
        ClaimRewards: 300000,
        Vote: 250000,
        GovDeposit: 250000,
        EnableAutoCompound: 250000,
        DisableAutoCompound: 250000,
      },
      gasPriceStep: {
        fast: 0.04,
        medium: 0.025,
        slow: 0.01,
      },
      bech32Prefix: {
        delegator: "certik",
      },
      gov: {
        vote: {
          useOptNumber: true,
        },
      },
      swuFees: 10,
      daysLocked: 21,
      msgsMixed: true,
    },
  },
  {
    ecosystem: "Tendermint",
    name: "juno",
    projectName: "juno",
    text: "Juno",
    description:
      "Juno is an open source platform for interoperable smart contracts for developers to efficiently and securely launch smart contracts using proven frameworks and compile them in various languages. It is built on the Cosmos SDK powered by Tendermint. JUNO is its native utility and governance token which has a max supply of 185 million.",
    tokenDescription: `JUNO, the native asset of the network carries a variety of use cases within the ecosystem, including <strong>securing the proof of stake network</strong>, key to on-chain governance, act as <strong>transport fuel</strong> for all interoperable smart contracts deployed in the ecosystem, <strong>collateral</strong> in various smart contract usecases and <strong>work token</strong> to capture value from dapps built on top of JUNO.`,
    logoSmall: require("@/assets/projects/juno-small-light.svg"),
    logoSmallDark: require("@/assets/projects/juno-small-dark.svg"),
    logo: require("@/assets/projects/juno-light.svg"),
    logoDark: require("@/assets/projects/juno-dark.svg"),
    implemented: true,
    config: {
      network: "juno",
      ableToLock: false,
      explorerAddrLink: "https://www.mintscan.io/juno/account/",
      explorerAddrTooltip: "View on mintscan",
      explorerTxsLink: "https://www.mintscan.io/juno/txs/",
      proposalDetailsLink: "https://www.mintscan.io/juno/proposals/",
      txOkTimeout: 10000,
      fixed: 6,
      rewardFixed: 6,
      refreshBlocks: 10,
      keystation: {
        lcd: process.env.VUE_APP_KEYSTATION_JUNO_LCD,
        clientWebUrl: window.location.origin,
        prefix: "juno",
      },
      keplr: {
        signDirect: true,
        signDirectMsgTypes: ["cosmos-sdk/MsgGrant", "cosmos-sdk/MsgRevoke"],
      },
    },
    staking: {
      denom: "ujuno",
      token: "juno",
      conversionRate: 1e6,
      gas: {
        Send: 250000,
        Stake: 160000,
        Unstake: 250000,
        Redelegate: 350000,
        ClaimRewards: 300000,
        Vote: 250000,
        GovDeposit: 250000,
        EnableAutoCompound: 250000,
        DisableAutoCompound: 250000,
      },
      gasPriceStep: {
        fast: 0.004,
        medium: 0.0025,
        slow: 0.001,
      },
      bech32Prefix: {
        delegator: "juno",
      },
      gov: {
        vote: {
          useOptNumber: true,
        },
      },
      swuFees: 5,
      daysLocked: 28,
      msgsMixed: true,
    },
  },
  {
    ecosystem: "Tendermint",
    name: "comdex",
    projectName: "comdex",
    text: "Comdex",
    description:
      "Comdex is a fully interoperable synthetics protocol that allow users to unlock access to a vast set of commodity debt assets and liquidity, making the flow of capital from DeFi to CeFi seamless. It is built on the Cosmos SDK powered by Tendermint. CMDX is its native staking and governance token which has a max supply of 200 million.",
    tokenDescription: `CMDX is the native staking token that helps to secure the Comdex ecosystem, the key to <strong>on-chain governance</strong> on critical parameters such as whitelisting of synthetics as well as collaterals that can be utilized on the CDP platform. Users can collateralize their CMDX holdings to <strong>create and trade synthetic cAssets on Comdex</strong>, and CMDX will be <strong>distributed as rewards to liquidity providers</strong> and other participants who perform critical functions in the network. CMDX tokens will be minted and burned to maintain the stability of cAssets in the network and ensure the solvency of the net debt of the network.`,
    logoSmall: require("@/assets/projects/comdex-small-light.svg"),
    logoSmallDark: require("@/assets/projects/comdex-small-dark.svg"),
    logo: require("@/assets/projects/comdex-light.svg"),
    logoDark: require("@/assets/projects/comdex-dark.svg"),
    implemented: true,
    config: {
      network: "comdex",
      ableToLock: false,
      explorerAddrLink: "https://www.mintscan.io/comdex/account/",
      explorerAddrTooltip: "View on mintscan",
      explorerTxsLink: "https://www.mintscan.io/comdex/txs/",
      proposalDetailsLink: "https://www.mintscan.io/comdex/proposals/",
      txOkTimeout: 10000,
      fixed: 6,
      rewardFixed: 6,
      refreshBlocks: 10,
      keystation: {
        lcd: process.env.VUE_APP_KEYSTATION_COMDEX_LCD,
        clientWebUrl: window.location.origin,
        prefix: "comdex",
      },
      keplr: {
        signDirect: true,
        signDirectMsgTypes: ["cosmos-sdk/MsgGrant", "cosmos-sdk/MsgRevoke"],
      },
    },
    staking: {
      denom: "ucmdx",
      token: "cmdx",
      conversionRate: 1e6,
      gas: {
        Send: 250000,
        Stake: 250000,
        Unstake: 250000,
        Redelegate: 350000,
        ClaimRewards: 300000,
        Vote: 250000,
        GovDeposit: 250000,
        EnableAutoCompound: 250000,
        DisableAutoCompound: 250000,
      },
      gasPriceStep: {
        fast: 0.04,
        medium: 0.025,
        slow: 0.01,
      },
      bech32Prefix: {
        delegator: "comdex",
      },
      gov: {
        vote: {
          useOptNumber: true,
        },
      },
      swuFees: 10,
      daysLocked: 21,
      msgsMixed: true,
    },
  },
  {
    ecosystem: "Tendermint",
    name: "lum",
    projectName: "lum",
    text: "Lum",
    description:
      "Lum Network is a fast, secure, and sustainable open-source blockchain protocol building a suite of tools for the retail market to make the right purchasing decisions. It is built on the Cosmos SDK powered by Tendermint. LUM is its native utility and governance token.",
    tokenDescription: `LUM is the native staking/governance token that helps to secure Lum Network. Companies and third party services that utilizes trust minimized services on the network will be required to pay fees, reward users, create and maintain their branded assets via LUM.`,
    logoSmall: require("@/assets/projects/lum-small.svg"),
    logo: require("@/assets/projects/lum-light.svg"),
    logoDark: require("@/assets/projects/lum-dark.svg"),
    implemented: true,
    config: {
      network: "lum",
      ableToLock: false,
      explorerAddrLink: "https://www.mintscan.io/lum/account/",
      explorerAddrTooltip: "View on mintscan",
      explorerTxsLink: "https://www.mintscan.io/lum/txs/",
      proposalDetailsLink: "https://www.mintscan.io/lum/proposals/",
      txOkTimeout: 10000,
      fixed: 6,
      rewardFixed: 6,
      refreshBlocks: 10,
      keplr: {
        signDirect: true,
        signDirectMsgTypes: ["cosmos-sdk/MsgGrant", "cosmos-sdk/MsgRevoke"],
      },
    },
    staking: {
      denom: "ulum",
      token: "lum",
      conversionRate: 1e6,
      gas: {
        Send: 250000,
        Stake: 250000,
        Unstake: 250000,
        Redelegate: 350000,
        ClaimRewards: 300000,
        Vote: 250000,
        GovDeposit: 250000,
        EnableAutoCompound: 250000,
        DisableAutoCompound: 250000,
      },
      gasPriceStep: {
        fast: 0.04,
        medium: 0.025,
        slow: 0.01,
      },
      bech32Prefix: {
        delegator: "lum",
      },
      gov: {
        vote: {
          useOptNumber: true,
        },
      },
      swuFees: 5,
      daysLocked: 21,
      msgsMixed: true,
    },
  },
  {
    ecosystem: "Tendermint",
    name: "gbridge",
    projectName: "gbridge",
    text: "Gravity Bridge",
    description:
      "Gravity bridge is an open, decentralized bridge that unlocks the power of interoperability & liquidity between blockchains, starting from Ethereum and the Cosmos ecosystem. It is built on the Cosmos SDK powered by Tendermint. GRAVITON is its native utility and governance token.",
    logoSmall: require("@/assets/projects/g-bridge-small.svg"),
    tokenDescription: `GRAV is the native staking/governance token that helps to secure the Gravity Bridge.`,
    logo: require("@/assets/projects/g-bridge.svg"),
    implemented: true,
    config: {
      network: "gbridge",
      ableToLock: false,
      explorerAddrLink: "https://www.mintscan.io/gravity-bridge/account/",
      explorerAddrTooltip: "View on mintscan",
      explorerTxsLink: "https://www.mintscan.io/gravity-bridge/txs/",
      proposalDetailsLink: "https://www.mintscan.io/gravity-bridge/proposals/",
      txOkTimeout: 10000,
      fixed: 6,
      rewardFixed: 6,
      refreshBlocks: 10,
      keystation: {
        lcd: process.env.VUE_APP_KEYSTATION_G_BRDIGE_LCD,
        clientWebUrl: window.location.origin,
        prefix: "gravity",
      },
      price: {
        fromOsmosis: true,
        token: "graviton",
        asset: "GRAV",
      },
      keplr: {
        signDirect: true,
        signDirectMsgTypes: ["cosmos-sdk/MsgGrant", "cosmos-sdk/MsgRevoke"],
      },
    },
    staking: {
      denom: "ugraviton",
      token: "graviton",
      conversionRate: 1e6,
      gas: {
        Send: 250000,
        Stake: 250000,
        Unstake: 250000,
        Redelegate: 350000,
        ClaimRewards: 300000,
        Vote: 250000,
        GovDeposit: 250000,
        EnableAutoCompound: 250000,
        DisableAutoCompound: 250000,
      },
      gasPriceStep: {
        fast: 0.04,
        medium: 0.025,
        slow: 0.01,
      },
      bech32Prefix: {
        delegator: "gravity",
      },
      gov: {
        vote: {
          useOptNumber: true,
        },
      },
      swuFees: 5,
      daysLocked: 21,
      msgsMixed: true,
    },
  },
  {
    ecosystem: "Tendermint",
    name: "evmos",
    projectName: "evmos",
    text: "Evmos",
    description:
      "Evmos is a scalable, high-throughput IBC-compatible EVM-based chain. It is built on the Cosmos SDK powered by Tendermint. EVMOS is its native utility and governance token which has no limit on max supply but with a target of one billion tokens in 4 years.",
    tokenDescription: `EVMOS is the native staking/governance token that helps to secure the Evmos chain.`,
    logoSmall: require("@/assets/projects/evmos-small-light.svg"),
    logoSmallDark: require("@/assets/projects/evmos-small-dark.svg"),
    logo: require("@/assets/projects/evmos-light.svg"),
    logoDark: require("@/assets/projects/evmos-dark.svg"),
    implemented: true,
    config: {
      network: "evmos",
      ableToLock: false,
      explorerAddrLink: "https://www.mintscan.io/evmos/account/",
      explorerAddrTooltip: "View on mintscan",
      explorerTxsLink: "https://www.mintscan.io/evmos/txs/",
      proposalDetailsLink: "https://www.mintscan.io/evmos/proposals/",
      txOkTimeout: 10000,
      fixed: 6,
      rewardFixed: 6,
      refreshBlocks: 10,
      keplr: {
        signDirect: true,
      },
      metamaskChainParams: {
        chainId:
          "0x" + Number(process.env.VUE_APP_EVMOS_ETH_CHAIN_ID).toString(16), // A 0x-prefixed hexadecimal string
        chainName: "Evmos",
        nativeCurrency: {
          name: "Evmos",
          symbol: "EVMOS",
          decimals: 18,
        },
        rpcUrls: [process.env.VUE_APP_EVMOS_METAMASK_RPC],
        blockExplorerUrls: [
          "https://evm.evmos.org",
          "https://www.mintscan.io/evmos",
        ],
      },
      blocksTimeout: 50,
    },
    staking: {
      denom: "aevmos",
      token: "evmos",
      conversionRate: 1e18,
      gas: {
        Send: 250000,
        Stake: 250000,
        Unstake: 250000,
        Redelegate: 350000,
        ClaimRewards: 250000,
        Vote: 250000,
        GovDeposit: 250000,
        EnableAutoCompound: 250000,
        DisableAutoCompound: 250000,
      },
      gasPriceStep: {
        fast: 80000000000,
        medium: 50000000000,
        slow: 50000000000,
      },
      bech32Prefix: {
        delegator: "evmos",
      },
      gov: {
        vote: {
          useOptNumber: true,
        },
      },
      swuFees: 5,
      daysLocked: 21,
      msgsMixed: true,
    },
  },
  {
    ecosystem: "Tendermint",
    name: "agoric",
    projectName: "agoric",
    text: "Agoric",
    description:
      "Agoric utilizes secure Javascript smart contracts to build and deploy DeFi applications with a dual token model to secure, govern, and transact on the network. It is built on the Cosmos SDK powered by Tendermint. It supports a local stable currency (RUN) for on-chain fee payments and a native utility and governance token (BLD).",
    logoSmall: require("@/assets/projects/agoric-small-light.svg"),
    logoSmallDark: require("@/assets/projects/agoric-small-dark.svg"),
    logo: require("@/assets/projects/agoric-light.svg"),
    logoDark: require("@/assets/projects/agoric-dark.svg"),
    implemented: true,
    config: {
      network: "agoric",
      ableToLock: false,
      explorerAddrLink: "https://agoric.bigdipper.live/accounts/",
      explorerAddrTooltip: "View on Big Dipper",
      explorerTxsLink: "https://agoric.bigdipper.live/transactions/",
      proposalDetailsLink: "https://agoric.bigdipper.live/proposals/",
      txOkTimeout: 10000,
      fixed: 6,
      rewardFixed: 6,
      refreshBlocks: 10,
      keplr: {
        signDirect: true,
        signDirectMsgTypes: ["cosmos-sdk/MsgGrant", "cosmos-sdk/MsgRevoke"],
      },
    },
    staking: {
      denom: "ubld",
      token: "bld",
      feeDenom: "run",
      conversionRate: 1e6,
      gas: {
        Send: 250000,
        Stake: 250000,
        Unstake: 250000,
        Redelegate: 350000,
        ClaimRewards: 300000,
        Vote: 250000,
        GovDeposit: 250000,
        EnableAutoCompound: 250000,
        DisableAutoCompound: 250000,
      },
      gasPriceStep: {
        fast: 0.04,
        medium: 0.025,
        slow: 0.01,
      },
      bech32Prefix: {
        delegator: "agoric",
      },
      gov: {
        vote: {
          useOptNumber: true,
        },
      },
      swuFees: 10,
      daysLocked: 21,
      msgsMixed: true,
    },
  },
  {
    ecosystem: "Tendermint",
    name: "injective",
    projectName: "injective",
    text: "Injective",
    description:
      "Injective is an open, interoperable, layer 1 blockchain built for finance applications. It provides a powerful smart contracts platform tailored for DeFi developers to quickly build and launch dApps for widespread use. Injective uniquely provides traditional finance infrastructures, such as an order book module, on-chain and is highly interoperable with prominent layer 1s, including Ethereum and Cosmos. INJ is its native utility and governance token.",
    tokenDescription: `INJ is the native staking/governance token that helps to secure the Injective chain and the deployment of unlimited markets on the decentralized derivative exchange.`,
    logoSmall: require("@/assets/projects/injective-small-light.svg"),
    logoSmallDark: require("@/assets/projects/injective-small-dark.svg"),
    logo: require("@/assets/projects/injective-light.svg"),
    logoDark: require("@/assets/projects/injective-dark.svg"),
    implemented: true,
    config: {
      network: "injective",
      ableToLock: false,
      explorerAddrLink: "https://www.mintscan.io/injective/account/",
      explorerAddrTooltip: "View on mintscan",
      explorerTxsLink: "https://www.mintscan.io/injective/txs/",
      proposalDetailsLink: "https://www.mintscan.io/injective/proposals/",
      txOkTimeout: 10000,
      fixed: 6,
      rewardFixed: 6,
      refreshBlocks: 10,
      keplr: {
        signDirect: true,
        signDirectMsgTypes: ["cosmos-sdk/MsgGrant", "cosmos-sdk/MsgRevoke"],
      },
      metamaskChainParams: {
        chainId:
          "0x" +
          Number(process.env.VUE_APP_INJECTIVE_ETH_CHAIN_ID).toString(16),
      },
      blocksTimeout: 50,
    },
    staking: {
      denom: "inj",
      token: "inj",
      conversionRate: 1e18,
      gas: {
        Send: 250000,
        Stake: 250000,
        Unstake: 250000,
        Redelegate: 350000,
        ClaimRewards: 250000,
        Vote: 250000,
        GovDeposit: 250000,
        EnableAutoCompound: 250000,
        DisableAutoCompound: 250000,
      },
      gasPriceStep: {
        fast: 10000000000,
        medium: 5000000000,
        slow: 2500000000,
      },
      bech32Prefix: {
        delegator: "inj",
      },
      gov: {
        vote: {
          useOptNumber: true,
        },
      },
      swuFees: 10,
      daysLocked: 21,
      msgsMixed: false,
    },
  },
  {
    ecosystem: "Tendermint",
    name: "akash",
    projectName: "akash",
    text: "Akash",
    description:
      "Akash Network is an open-source cloud platform with a distributed peer-to-peer marketplace for cloud computing. It is built on the Cosmos SDK and  powered by Tendermint. AKT is its native utility and governance token which has a max supply of 388 million.",
    logoSmall: require("@/assets/projects/akash-small-light.svg"),
    logoSmallDark: require("@/assets/projects/akash-small-dark.svg"),
    tokenDescription: `AKT is the cloud compute platform's native utility token used to incentivize participations, store and exchange value, used for governance participation and to secure the blockchain.`,
    logo: require("@/assets/projects/akash.svg"),
    implemented: true,
    config: {
      network: "akash",
      ableToLock: false,
      explorerAddrLink: "https://www.mintscan.io/akash/account/",
      explorerAddrTooltip: "View on mintscan",
      explorerTxsLink: "https://www.mintscan.io/akash/txs/",
      proposalDetailsLink: "https://www.mintscan.io/akash/proposals/",
      txOkTimeout: 10000,
      fixed: 6,
      rewardFixed: 6,
      refreshBlocks: 10,
      keplr: {
        signDirect: true,
        signDirectMsgTypes: ["cosmos-sdk/MsgGrant", "cosmos-sdk/MsgRevoke"],
      },
      keystation: {
        lcd: process.env.VUE_APP_KEYSTATION_AKASH_LCD,
        clientWebUrl: window.location.origin,
        prefix: "akash",
      },
    },
    staking: {
      denom: "uakt",
      token: "akt",
      conversionRate: 1e6,
      gas: {
        Send: 250000,
        Stake: 250000,
        Unstake: 250000,
        Redelegate: 350000,
        ClaimRewards: 300000,
        Vote: 250000,
        GovDeposit: 250000,
        EnableAutoCompound: 250000,
        DisableAutoCompound: 250000,
      },
      gasPriceStep: {
        fast: 0.04,
        medium: 0.025,
        slow: 0.01,
      },
      bech32Prefix: {
        delegator: "akash",
      },
      gov: {
        vote: {
          useOptNumber: true,
        },
      },
      swuFees: 5,
      daysLocked: 21,
      msgsMixed: true,
    },
  },
  {
    ecosystem: "Tendermint",
    name: "sifchain",
    projectName: "sifchain",
    text: "Sifchain",
    description:
      "Sifchain is an omnichain DEX which inherits cross-chain capabilities of Thorchain, between Ethereum and Cosmos with faster transactions and lower fees on its network. It is built on the Cosmos SDK powered by Tendermint. ROWAN is its native utility and governance token.",
    tokenDescription: `ROWAN is the native token for Sifchain that is used as the universal liquidity pairing token of SifDEX, the staking token for governance participation and to secure the Sifchain network.`,
    logoSmall: require("@/assets/projects/sifchain-small.svg"),
    logo: require("@/assets/projects/sifchain.svg"),
    implemented: true,
    config: {
      network: "sifchain",
      ableToLock: false,
      explorerAddrLink: "https://www.mintscan.io/sifchain/account/",
      explorerAddrTooltip: "View on mintscan",
      explorerTxsLink: "https://www.mintscan.io/sifchain/txs/",
      proposalDetailsLink: "https://www.mintscan.io/sifchain/proposals/",
      txOkTimeout: 10000,
      fixed: 6,
      rewardFixed: 6,
      refreshBlocks: 10,
      keplr: {
        signDirect: false,
      },
      keystation: {
        lcd: process.env.VUE_APP_KEYSTATION_SIFCHAIN_LCD,
        clientWebUrl: window.location.origin,
        prefix: "sif",
      },
    },
    staking: {
      denom: "rowan",
      token: "rowan",
      conversionRate: 1e18,
      gas: {
        Send: 250000,
        Stake: 250000,
        Unstake: 250000,
        Redelegate: 350000,
        ClaimRewards: 300000,
        Vote: 250000,
        GovDeposit: 250000,
        EnableAutoCompound: 250000,
        DisableAutoCompound: 250000,
      },
      gasPriceStep: {
        slow: 1000000000000,
        medium: 1500000000000,
        fast: 2000000000000,
      },
      bech32Prefix: {
        delegator: "sif",
      },
      gov: {
        vote: {
          useOptNumber: true,
        },
      },
      swuFees: 5,
      daysLocked: 21,
      msgsMixed: true,
    },
  },
  {
    ecosystem: "Tendermint",
    name: "archway",
    projectName: "archway",
    text: "Archway",
    description:
      "Archway is an incentivized smart contract platform built on Cosmos SDK with support for WASM execution that rewards developers. Archway rewards developers based on the value and impact of their dApp, rather than the connections to capital.",
    logoSmall: require("@/assets/projects/archway-small.svg"),
    logo: require("@/assets/projects/archway-light.svg"),
    logoDark: require("@/assets/projects/archway-dark.svg"),
    implemented: true,
    config: {
      network: "archway",
      ableToLock: false,
      explorerAddrLink: "https://mintscan.io/archway/account/",
      explorerAddrTooltip: "View on mintscan",
      explorerTxsLink: "https://mintscan.io/archway/txs/",
      proposalDetailsLink: "https://mintscan.io/archway/proposals/",
      txOkTimeout: 10000,
      fixed: 6,
      rewardFixed: 6,
      refreshBlocks: 10,
      keplr: {
        signDirect: true,
        signDirectMsgTypes: ["cosmos-sdk/MsgGrant", "cosmos-sdk/MsgRevoke"],
      },
    },
    staking: {
      denom: "aarch",
      token: "arch",
      conversionRate: 1e18,
      gas: {
        Send: 200000,
        Stake: 200000,
        Unstake: 200000,
        Redelegate: 200000,
        ClaimRewards: 200000,
        Vote: 200000,
        GovDeposit: 200000,
        EnableAutoCompound: 200000,
        DisableAutoCompound: 200000,
      },
      gasPriceStep: {
        fast: 2000000000000,
        medium: 1500000000000,
        slow: 1000000000000,
      },
      bech32Prefix: {
        delegator: "archway",
      },
      gov: {
        vote: {
          useOptNumber: true,
        },
      },
      swuFees: 5,
      daysLocked: 21,
      msgsMixed: true,
    },
  },
  {
    ecosystem: "Tendermint",
    name: "passage3d",
    projectName: "passage3d",
    text: "Passage",
    description:
      "Passage is an accessible and immersive 3D virtual worlds ecosystem, built using Unreal Engine 5, combined with spatialized audio and video chat for work and entertainment. It is built on the Cosmos SDK powered by Tendermint. PASG is its native utility and staking token which has a max supply of 2 billion.",
    tokenDescription: `The PASG token is a utility token that allows users to stream and build worlds. It also has inbuilt staking functionality allowing stakers to earn inflationary staking rewards, marketplace fees, enjoy marketplace discount and obtain in-world benefits as well as governance rights to the Passage ecossytem.`,
    logoSmall: require("@/assets/projects/passage3d-small-dark.svg"),
    logoSmallDark: require("@/assets/projects/passage3d-small-light.svg"),
    logo: require("@/assets/projects/passage3d-dark.svg"),
    logoDark: require("@/assets/projects/passage3d-light.svg"),
    implemented: true,
    config: {
      network: "passage3d",
      ableToLock: false,
      explorerAddrLink: "https://www.mintscan.io/passage/account/",
      explorerAddrTooltip: "View on mintscan",
      explorerTxsLink: "https://www.mintscan.io/passage/txs/",
      proposalDetailsLink: "https://www.mintscan.io/passage/proposals/",
      txOkTimeout: 10000,
      fixed: 6,
      rewardFixed: 6,
      refreshBlocks: 10,
      keplr: {
        signDirect: true,
        signDirectMsgTypes: ["cosmos-sdk/MsgGrant", "cosmos-sdk/MsgRevoke"],
      },
    },
    staking: {
      denom: "upasg",
      feeDenom: "upasg",
      token: "pasg",
      conversionRate: 1e6,
      gas: {
        Send: 350000,
        Stake: 350000,
        Unstake: 350000,
        Redelegate: 350000,
        ClaimRewards: 350000,
        Vote: 350000,
        GovDeposit: 350000,
        EnableAutoCompound: 350000,
        DisableAutoCompound: 350000,
      },
      gasPriceStep: {
        fast: 0.04,
        medium: 0.025,
        slow: 0.01,
      },
      bech32Prefix: {
        delegator: "pasg",
      },
      gov: {
        vote: {
          useOptNumber: true,
        },
      },
      swuFees: 9,
      daysLocked: 21,
      msgsMixed: true,
    },
  },
  {
    ecosystem: "Tendermint",
    name: "quicksilver",
    projectName: "quicksilver",
    text: "Quicksilver",
    description:
      "Quicksilver is a sovereign liquid staking deriviative protocol providing liquid staking for the Cosmos Interchain ecosystem that scales to any validators across IBC-enabled chains by default. It maximizes liquidity and capital efficiency while also improving network security and decentralization.",
    logoSmall: require("@/assets/projects/quicksilver-small.png"),
    logoSmallDark: require("@/assets/projects/quicksilver-small.png"),
    logo: require("@/assets/projects/quicksilver-light.png"),
    logoDark: require("@/assets/projects/quicksilver-dark.png"),
    implemented: true,
    isLegacy: true,
    config: {
      network: "quicksilver",
      ableToLock: false,
      explorerAddrLink: "https://www.mintscan.io/quicksilver/account/",
      explorerAddrTooltip: "View on mintscan",
      explorerTxsLink: "https://www.mintscan.io/quicksilver/txs/",
      proposalDetailsLink: "https://www.mintscan.io/quicksilver/proposals/",
      txOkTimeout: 10000,
      fixed: 6,
      rewardFixed: 6,
      refreshBlocks: 10,
      keplr: {
        signDirect: true,
        signDirectMsgTypes: ["cosmos-sdk/MsgGrant", "cosmos-sdk/MsgRevoke"],
      },
    },
    staking: {
      denom: "uqck",
      feeDenom: "uqck",
      token: "qck",
      conversionRate: 1e6,
      gas: {
        Send: 350000,
        Stake: 350000,
        Unstake: 350000,
        Redelegate: 350000,
        ClaimRewards: 350000,
        Vote: 350000,
        GovDeposit: 350000,
        EnableAutoCompound: 350000,
        DisableAutoCompound: 350000,
      },
      gasPriceStep: {
        fast: 0.00025,
        medium: 0.0001,
        slow: 0.0001,
      },
      bech32Prefix: {
        delegator: "quick",
      },
      gov: {
        vote: {
          useOptNumber: true,
        },
      },
      swuFees: 9,
      daysLocked: 21,
      msgsMixed: true,
    },
  },
  {
    ecosystem: "Solana",
    name: "solana",
    projectName: "solana",
    text: "Solana",
    description:
      "Solana is an open source project implementing a new, high-performance, permissionless blockchain built to enable scalable, user-friendly apps for the world. SOL is its native utility and governance token.",
    tokenDescription:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sit voluptate eligendi quae ipsam consequatur! Tempore fuga inventore sunt rerum sequi. Dolore commodi, sunt perferendis modi maiores corrupti quod molestiae rem.",
    logoSmall: require("@/assets/projects/solana-small.svg"),
    logoSmallDark: require("@/assets/projects/solana-small.svg"),
    logo: require("@/assets/projects/solana-light.svg"),
    logoDark: require("@/assets/projects/solana-dark.svg"),
    implemented: true,
    config: {
      network: "solana",
      isNew: false,
      explorerAddrLink: "https://solanabeach.io/address/",
      explorerAddrTooltip: "View on Solana Beach",
      explorerTxsLink: "https://solanabeach.io/transaction/",
    },
    staking: {
      denom: "sol",
      token: "sol",
      conversionRate: 1,
    },
  },
  {
    ecosystem: "Sui",
    name: "sui",
    projectName: "sui",
    text: "Sui",
    description:
      "Sui Network is an innovative Layer 1 blockchain network based off the Move programming langauge. Sui allows for most transactions to be processed in parallel and supports smart contract written in Sui Move.",
    tokenDescription:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sit voluptate eligendi quae ipsam consequatur! Tempore fuga inventore sunt rerum sequi. Dolore commodi, sunt perferendis modi maiores corrupti quod molestiae rem.",
    logoSmall: require("@/assets/projects/sui-small-light.svg"),
    logoSmallDark: require("@/assets/projects/sui-small-dark.svg"),
    logo: require("@/assets/projects/sui-light.svg"),
    logoDark: require("@/assets/projects/sui-dark.svg"),
    implemented: true,
    config: {
      network: "sui",
      isNew: false,
      isOther: true,
      explorerAddrLink: "https://explorer.sui.io/address/",
      explorerAddrTooltip: "View on Sui explorer",
      explorerTxsLink: "https://explorer.sui.io/txblock/",
    },
    staking: {
      denom: "sui",
      token: "sui",
      conversionRate: 1,
    },
  },
  {
    ecosystem: "Tendermint",
    name: "kujira",
    projectName: "kujira",
    text: "Kujira",
    variesApy: true,
    description: "Kujira is the blockchain for real yield - a decentralized ecosystem of financial products and payment infrastructure based off Cosmos SDK.",
    logoSmall: require("@/assets/projects/kujira-small.svg"),
    logoSmallDark: require("@/assets/projects/kujira-small.svg"),
    logo: require("@/assets/projects/kujira-small.svg"),
    logoDark: require("@/assets/projects/kujira-small.svg"),
    implemented: true,
    isLegacy: true,
    config: {
      network: "kujira",
      ableToLock: false,
      explorerAddrLink: "https://finder.kujira.network/kaiyo-1/address/",
      explorerAddrTooltip: "View on Kujira Finder",
      explorerTxsLink: "https://finder.kujira.network/kaiyo-1/tx/",
      proposalDetailsLink: "https://blue.kujira.network/govern/",
      txOkTimeout: 10000,
      fixed: 6,
      rewardFixed: 6,
      refreshBlocks: 10,
      keplr: {
        signDirect: true,
        signDirectMsgTypes: ["cosmos-sdk/MsgGrant", "cosmos-sdk/MsgRevoke"],
      },
      isNew: false
    },
    staking: {
      denom: "ukuji",
      feeDenom: "ukuji",
      token: "kuji",
      conversionRate: 1e6,
      gas: {
        Send: 500000,
        Stake: 500000,
        Unstake: 500000,
        Redelegate: 500000,
        ClaimRewards: 500000,
        Vote: 500000,
        GovDeposit: 500000,
        EnableAutoCompound: 500000,
        DisableAutoCompound: 500000,
      },
      gasPriceStep: {
        fast: 0.005,
        medium: 0.0025,
        slow: 0.0025,
      },
      bech32Prefix: {
        delegator: "kujira",
      },
      gov: {
        vote: {
          useOptNumber: true,
        },
      },
      swuFees: 5,
      daysLocked: 14,
      msgsMixed: true,
    },
  },
  {
    ecosystem: "Tendermint",
    name: "celestia",
    projectName: "celestia",
    text: "Celestia",
    description: "Celestia is a modular consensus and data network, built to enable anyone to easily deploy their own blockchain with minimal overhead. By decoupling the consensus and application execution layers, Celestia modularizes the blockchain technology stack and unlocks new possibilities for decentralized application builders.",
    tokenDescription: "The TIA token is paid by rollups to publish data to Celestia’s blobspace, is used by stakers to participate in consensus and secure Celestia and is used by developers as a gas token for their rollups.",
    logoSmall: require("@/assets/projects/celestia-small.png"),
    logoSmallDark: require("@/assets/projects/celestia-small.png"),
    logo: require("@/assets/projects/celestia-small.png"),
    logoDark: require("@/assets/projects/celestia-small.png"),
    implemented: true,
    config: {
      network: "celestia",
      ableToLock: false,
      explorerAddrLink: "https://mintscan.io/celestia/account/",
      explorerAddrTooltip: "View on mintscan",
      explorerTxsLink: "https://mintscan.io/celestia/txs/",
      proposalDetailsLink: "https://mintscan.io/celestia/proposals/",
      txOkTimeout: 10000,
      fixed: 6,
      rewardFixed: 6,
      refreshBlocks: 10,
      keplr: {
        signDirect: true,
        signDirectMsgTypes: ["cosmos-sdk/MsgGrant", "cosmos-sdk/MsgRevoke"],
      },
      isNew: false
    },
    staking: {
      denom: "utia",
      feeDenom: "utia",
      token: "tia",
      conversionRate: 1e6,
      gas: {
        Send: 500000,
        Stake: 500000,
        Unstake: 500000,
        Redelegate: 500000,
        ClaimRewards: 500000,
        Vote: 500000,
        GovDeposit: 500000,
        EnableAutoCompound: 500000,
        DisableAutoCompound: 500000,
      },
      gasPriceStep: {
        fast: 0.4,
        medium: 0.2,
        slow: 0.1,
      },
      bech32Prefix: {
        delegator: "celestia",
      },
      gov: {
        vote: {
          useOptNumber: true,
        },
      },
      swuFees: 5,
      daysLocked: 14,
      msgsMixed: true,
    },
  },
  {
    ecosystem: "Tendermint",
    name: "dydx",
    projectName: "dydx",
    text: "dYdX",
    variesApy: true,
    description: "dYdX is the leading perpetual protocol featuring a fully decentralized, off-chain, orderbook and matching engine on a Cosmos based standalone app-chain. Besides offering up to 2,000 transactions per second, the dYdX chain offers full customizability over the entire tech stack through onchain governance.",
    tokenDescription: "The DYDX token is used as a staking token to validators to govern the chain. Traders do not need to pay gas fees to trade, but rather pay fees based on trades executed. These fees are then accrued to validators and stakers.",
    logoSmall: require("@/assets/projects/dydx.svg"),
    logoSmallDark: require("@/assets/projects/dydx.svg"),
    logo: require("@/assets/projects/dydx.svg"),
    logoDark: require("@/assets/projects/dydx.svg"),
    implemented: true,
    config: {
      network: "dydx",
      bridgeNetwork: "ethereum",
      bridgeWallet: "metamask",
      ableToLock: false,
      explorerAddrLink: "https://mintscan.io/dydx/account/",
      explorerAddrTooltip: "View on mintscan",
      explorerTxsLink: "https://mintscan.io/dydx/txs/",
      explorerBridgeLink: "https://etherscan.io/tx/",
      proposalDetailsLink: "https://mintscan.io/dydx/proposals/",
      txOkTimeout: 10000,
      fixed: 6,
      rewardFixed: 6,
      refreshBlocks: 10,
      keplr: {
        signDirect: true,
        signDirectMsgTypes: ["cosmos-sdk/MsgGrant", "cosmos-sdk/MsgRevoke"],
      },
      isNew: true
    },
    staking: {
      denom: "adydx",
      token: "dydx",
      conversionRate: 1e18,
      gas: {
        Send: 500000,
        Stake: 500000,
        Unstake: 500000,
        Redelegate: 500000,
        ClaimRewards: 500000,
        Vote: 500000,
        GovDeposit: 500000,
        EnableAutoCompound: 500000,
        DisableAutoCompound: 500000,
      },
      rewards: [{
        denom: 'adydx',
        decimal: 18,
        display: 'DYDX',
        isNative: true,
      },{
        denom: 'ibc/8E27BA2D5493AF5636760E354E46004562C46AB7EC0CC4C1CA14E9E20E2545B5',
        display: 'USDC',
        decimal: 18,
      }],
      gasPriceStep: {
        fast: 12500000000,
        medium: 12500000000,
        slow: 12500000000,
      },
      bech32Prefix: {
        delegator: "dydx",
      },
      gov: {
        vote: {
          useOptNumber: true,
        },
      },
      swuFees: 5,
      daysLocked: 30,
      msgsMixed: true,
    },
  },
  {
    ecosystem: "Tendermint",
    name: "dymension",
    projectName: "dymension",
    text: "Dymension",
    description: "Dymension is a home for easily deployable and lightning fast app-chains, called RollApps. Dymension is a decentralized Delegated Proof-of-Stake L1 blockchain secured by the DYM token.",
    tokenDescription: "Besides being used as governance tokens, there are 3 additional demand sinks for the DYM token. DYM tokens are systematically burned as part of validating bridging fee and protocol swap fees. All fees generated from blockspace demand are distributed amongst DYM validators and their stakers. DYM is also required as a RollApp bond, which helps to reduce the circulating supply of DYM, enhancing the network's security and stability.",
    logoSmall: require("@/assets/projects/dymension.png"),
    logoSmallDark: require("@/assets/projects/dymension-dark.png"),
    logo: require("@/assets/projects/dymension-light.png"),
    logoDark: require("@/assets/projects/dymension-dark.png"),
    implemented: true,
    config: {
      network: "dymension",
      ableToLock: false,
      explorerAddrLink: "https://mintscan.io/dymension/account/",
      explorerAddrTooltip: "View on mintscan",
      explorerTxsLink: "https://mintscan.io/dymension/txs/",
      proposalDetailsLink: "https://mintscan.io/dymension/proposals/",
      txOkTimeout: 10000,
      fixed: 6,
      rewardFixed: 6,
      refreshBlocks: 10,
      keplr: {
        signDirect: true,
      },
      metamaskChainParams: {
        chainId:
          "0x" + Number(1100).toString(16), // A 0x-prefixed hexadecimal string
        chainName: "Dymension",
        nativeCurrency: {
          name: "Dymension",
          symbol: "DYM",
          decimals: 18,
        },
        rpcUrls: ['https://dymension-evm.blockpi.network/v1/rpc/public', 'https://dymension-evm-rpc.publicnode.com'],
        blockExplorerUrls: [
          "https://dymension.xyz",
          "https://www.mintscan.io/dymension",
        ],
      },
      isNew: false
    },
    staking: {
      denom: "adym",
      token: "dym",
      conversionRate: 1e18,
      gas: {
        Send: 300000,
        Stake: 300000,
        Unstake: 300000,
        Redelegate: 300000,
        ClaimRewards: 300000,
        Vote: 300000,
        GovDeposit: 300000,
        EnableAutoCompound: 300000,
        DisableAutoCompound: 300000,
      },
      gasPriceStep: {
        fast: 12500000000,
        medium: 12500000000,
        slow: 12500000000,
      },
      bech32Prefix: {
        delegator: "dym",
      },
      gov: {
        vote: {
          useOptNumber: true,
        },
      },
      swuFees: 5,
      daysLocked: 21,
      msgsMixed: true,
    },
  },
  {
    ecosystem: "Tendermint",
    name: "canto",
    projectName: "canto",
    text: "Canto",
    description: "Canto is a permissionless general-purpose blockchain running the EVM to deliver DeFi via Free Public Infrastructure primitives.",
    tokenDescription: "CANTO is used to pay gas fees for transactions and be staked to validators to help secure the network. CANTO are also emitted for liquidity mining purposes.",
    logoSmall: require("@/assets/projects/canto.svg"),
    logoSmallDark: require("@/assets/projects/canto.svg"),
    logo: require("@/assets/projects/canto.svg"),
    logoDark: require("@/assets/projects/canto.svg"),
    implemented: true,
    isLegacy: true,
    config: {
      network: "canto",
      ableToLock: false,
      explorerAddrLink: "https://mintscan.io/canto/account/",
      explorerAddrTooltip: "View on mintscan",
      explorerTxsLink: "https://mintscan.io/canto/txs/",
      proposalDetailsLink: "https://mintscan.io/canto/proposals/",
      txOkTimeout: 10000,
      fixed: 6,
      rewardFixed: 6,
      refreshBlocks: 10,
      keplr: {
        signDirect: true,
      },
      metamaskChainParams: {
        chainId:
          "0x" + Number(7700).toString(16), // A 0x-prefixed hexadecimal string
        chainName: "Canto",
        nativeCurrency: {
          name: "Canto",
          symbol: "CANTO",
          decimals: 18,
        },
        rpcUrls: ['https://mainnode.plexnode.org:8545', 'https://canto.slingshot.finance', 'https://canto.gravitychain.io'],
        blockExplorerUrls: [
          "https://evm.explorer.canto.io",
          "https://www.mintscan.io/canto",
        ],
      }
    },
    staking: {
      denom: "acanto",
      token: "canto",
      conversionRate: 1e18,
      gas: {
        Send: 300000,
        Stake: 300000,
        Unstake: 300000,
        Redelegate: 300000,
        ClaimRewards: 300000,
        Vote: 300000,
        GovDeposit: 300000,
        EnableAutoCompound: 300000,
        DisableAutoCompound: 300000,
      },
      gasPriceStep: {
        fast: 1500000000000,
        medium: 1200000000000,
        slow: 1000000000000,
      },
      bech32Prefix: {
        delegator: "canto",
      },
      gov: {
        vote: {
          useOptNumber: true,
        },
      },
      swuFees: 5,
      daysLocked: 21,
      msgsMixed: true,
    },
  },
];
